import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { DialogService } from 'src/app/services/dialog.service';
import { formatError } from 'src/app/utils/errorMessage.formatter';
import { ListParams } from 'src/app/models/list-params/list-params.model';
import { ContentListService } from 'src/app/services/content-list.service';
import { ContentLists } from 'src/app/models/content-list/content-lists.model';

@Component({
    selector: 'app-content-lists-list',
    templateUrl: './content-lists-list.component.html',
    styleUrls: ['./content-lists-list.component.scss'],
    standalone: false
})
export class ContentListsListComponent implements OnInit {
    headers = [
        { label:"Title", key:"title", sortable: true },
        { label:"Actions" },
    ];

    currentPage = 1;
    searchTerm = "";
    sorting = false;
    loading = false;
    contentLists:ContentLists;
    sortingParams:{ key?:string, asc?:boolean };
    
    constructor(
        private router:Router,
        private authService:AuthService,
        private dialogService:DialogService,
        private contentListService:ContentListService
    ) { }

    ngOnInit():void {
        this.loadList();
    }

    loadList(hideLoader?:boolean):void {
        var params:ListParams = { page: this.currentPage };
        if (this.searchTerm) 
            params.text = this.searchTerm;
        
        if (this.sortingParams) {
            params.orderBy = this.sortingParams.key;
            params.sort = this.sortingParams.asc ? "asc" : "desc";
        }

        if (!hideLoader)
            this.loading = true;

        this.contentListService.list(params)
            .subscribe(response => {
                this.sorting = false;
                this.loading = false;
                this.contentLists = response;
            }, 
            errors => {
                this.sorting = false;
                this.loading = false;
                this.dialogService.showErrorAlert(formatError(errors));
                if (errors.status === 401) {
                    this.authService.clearSession();
                    this.router.navigate(['/login']);
                }
            }
        );
    }

    onPageChange(newPage:number) {
        this.currentPage = newPage;
        this.loadList();
    }

    onSearchChange(term:string) {
        this.searchTerm = term;
        this.currentPage = 1;
        this.loadList();
    }

    onSortChange(params:{ key:string, asc:boolean }) {
        this.sorting = true;
        this.sortingParams = params;
        this.loadList(true);
    }
}
